export default __webpack_public_path__ + "static/media/img2.f2ebf34b.png";